function tryCatch<T>(tryFn: () => T): T | undefined;
function tryCatch<T, C>(tryFn: () => T, catchFn: (err: unknown) => C): T | C;
function tryCatch<T, C, F>(
  tryFn: () => T,
  catchFn: ((err: unknown) => C) | undefined,
  finallyFn: () => F
): F;
function tryCatch<T, C, F>(
  tryFn: () => T,
  catchFn?: (err: unknown) => C,
  finallyFn?: () => F
): T | C | F | undefined {
  try {
    return tryFn();
  } catch (err) {
    if (catchFn) return catchFn(err);
  } finally {
    // eslint-disable-next-line no-unsafe-finally
    if (finallyFn) return finallyFn();
  }
}

export default tryCatch;
